import { Lead } from "@kanda-libs/ks-frontend-services";
import type { FunctionComponent } from "react";
import { formatLeadSource, formatLeadStatus } from "./helpers";
import useLeadTableActions from "./useLeadTableActions";

export interface LeadTableActionsProps {
  availableSources?: Lead["source"][];
  availableStatuses?: Lead["status"][];
}

const LeadTableActions: FunctionComponent<LeadTableActionsProps> = function ({
  availableSources = ["", "consumer", "checkout"],
  availableStatuses = [
    "",
    "open",
    "issued",
    "credit_declined",
    "quote_declined",
    "trade_accepted",
    "trade_declined",
    "trade_notified",
    "expired",
    "closed",
  ],
}) {
  const { statuses, activeStatus, onStatusChange, onSourceChange } =
    useLeadTableActions(availableStatuses);

  return (
    <div className="flex flex-row gap-x-2">
      <div className="mb-4 -mt-8">
        Status:
        <select onChange={onStatusChange}>
          <option>{formatLeadStatus(activeStatus)}</option>
          {statuses.map((status) => (
            <option value={status}>{formatLeadStatus(status)}</option>
          ))}
        </select>
      </div>
      <div className="mb-4 -mt-8">
        Flow:
        <select onChange={onSourceChange}>
          {availableSources.map((currentSource) => (
            <option value={currentSource}>
              {formatLeadSource(currentSource)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LeadTableActions;
